import { ChangeDetectionStrategy, Component, ElementRef, inject, signal, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { Sidebar } from './sidebar';
import { Toast } from './toast';

@Component({
  selector: 'tc-app-shell',
  imports: [RouterOutlet, Sidebar, Toast],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <header class="topbar">
      <button class="menu" type="button" aria-label="Open navigation" (click)="open.set(true)">
        <svg viewBox="0 0 16 16" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M2 4h12M2 8h12M2 12h12"/></svg>
      </button>
      <span class="title">Vergabe-Suche</span>
    </header>
    @if (open()) {
      <div class="scrim" (click)="open.set(false)"></div>
    }
    <tc-sidebar class="side" [class.open]="open()" (navigated)="open.set(false)" />
    <main #main class="main"><router-outlet /></main>
    <tc-toast />
  `,
  styles: `
    :host {
      display: flex;
      height: 100vh;
    }
    .side {
      flex: 0 0 232px;
      width: 232px;
    }
    .main {
      flex: 1;
      min-width: 0;
      overflow-y: auto;
      background: var(--canvas);
    }
    .topbar,
    .scrim {
      display: none;
    }
    @media (max-width: 900px) {
      :host {
        flex-direction: column;
      }
      .topbar {
        display: flex;
        align-items: center;
        gap: 10px;
        height: 48px;
        padding: 0 12px;
        background: var(--subtle);
        border-bottom: 1px solid var(--border);
        flex: 0 0 auto;
      }
      .menu {
        border: 0;
        background: none;
        padding: 6px;
        display: inline-flex;
      }
      .title {
        font-weight: 600;
      }
      .side {
        position: fixed;
        z-index: 20;
        top: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        transition: transform 0.15s ease;
        &.open {
          transform: none;
        }
      }
      .scrim {
        display: block;
        position: fixed;
        inset: 0;
        z-index: 10;
        background: rgba(18, 33, 31, 0.3);
      }
    }
  `,
})
export class AppShell {
  protected readonly open = signal(false);
  private readonly main = viewChild.required<ElementRef<HTMLElement>>('main');

  constructor() {
    // The content area scrolls on its own, so restore the scroll position here.
    inject(Router)
      .events.pipe(
        filter((e) => e instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe(() => this.main().nativeElement.scrollTo({ top: 0 }));
  }
}
